import React, { useState } from "react";

import { Link } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

import {
  FiChevronRight,
  FiHome,
  FiLock,
  FiLoader,
  FiAlertCircle,
  FiSave,
} from "react-icons/fi";

import toast from "react-hot-toast";

import { changePassword } from "../../store/slices/profile";

const ChangePassword = () => {
  const dispatch = useDispatch();

  const {
    loading,
    error,
  } = useSelector((state) => state.profile);

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [validationError, setValidationError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setValidationError("");

    const trimmedOldPassword = oldPassword.trim();
    const trimmedNewPassword = newPassword.trim();

    if (!trimmedOldPassword) {
      setValidationError("Please enter your old password.");
      return;
    }

    if (!trimmedNewPassword) {
      setValidationError("Please enter your new password.");
      return;
    }

    if (trimmedNewPassword.length < 6) {
      setValidationError(
        "New password must be at least 6 characters."
      );
      return;
    }

    if (trimmedOldPassword === trimmedNewPassword) {
      setValidationError(
        "New password must be different from old password."
      );
      return;
    }

    try {
      const payload = {
        oldPassword: trimmedOldPassword,
        newPassword: trimmedNewPassword,
      };

      console.log("CHANGE PASSWORD PAYLOAD:", payload);

      await dispatch(changePassword(payload)).unwrap();

      toast.success("Password changed successfully");

      setOldPassword("");
      setNewPassword("");
    } catch (err) {
      console.error("CHANGE PASSWORD ERROR:", err);

      toast.error(
        typeof err === "string"
          ? err
          : err?.message || "Failed to change password"
      );
    }
  };

  const errorMessage = validationError || error;

  return (
    <div className="gi-referral-page">

      {/* ================= BREADCRUMB ================= */}

      <div className="gi-breadcrumb">
        <Link to="/dashboard">
          <FiHome />
          Dashboard
        </Link>

        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>Settings</span>

        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>Change Password</span>
      </div>

      {/* ================= FORM ================= */}

      <section className="gi-transfer-card">

        <form
          onSubmit={handleSubmit}
          className="gi-transfer-form"
        >

          {/* ================= OLD PASSWORD ================= */}

          <div className="gi-transfer-form-group">
            <label htmlFor="oldPassword">
              Old Password
              <span>*</span>
            </label>

            <div className="gi-transfer-input-wrapper">
              <FiLock />

              <input
                id="oldPassword"
                type="password"
                value={oldPassword}
                onChange={(e) => {
                  setOldPassword(e.target.value);
                  setValidationError("");
                }}
                placeholder="Enter your old password"
                className="gi-transfer-input"
                disabled={loading}
                autoComplete="current-password"
              />
            </div>
          </div>

          {/* ================= NEW PASSWORD ================= */}

          <div className="gi-transfer-form-group">
            <label htmlFor="newPassword">
              New Password
              <span>*</span>
            </label>

            <div className="gi-transfer-input-wrapper">
              <FiLock />

              <input
                id="newPassword"
                type="password"
                value={newPassword}
                onChange={(e) => {
                  setNewPassword(e.target.value);
                  setValidationError("");
                }}
                placeholder="Enter your new password"
                className="gi-transfer-input"
                disabled={loading}
                autoComplete="new-password"
              />
            </div>
          </div>

          {/* ================= ERROR ================= */}

          {errorMessage && (
            <div className="gi-transfer-error">
              <FiAlertCircle />
              <span>{errorMessage}</span>
            </div>
          )}

          {/* ================= SUBMIT ================= */}

          <button
            type="submit"
            className="gi-transfer-submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <FiLoader className="gi-transfer-spinner" />
                Changing Password...
              </>
            ) : (
              <>
                <FiSave />
                Change Password
              </>
            )}
          </button>

        </form>
      </section>
    </div>
  );
};

export default ChangePassword;
